export default {
  APPROVED: `Approuvée`,
  ACKNOWLEDGED: `Reçue`,
  IN_PROGRESS: `En cours de traitement`,
  JUSTIFIED: `Justifiée`,
  UNJUSTIFIED: `Non justifiée`,
  REFUSED: `Refusée`,
  CANCELLED: `Annulée`,
  APPROVAL_REQUIRED: `Approbation nécéssaire`,
  CHANGES_REQUESTED: `Changements demandés`
}
